import { createContext } from 'react';
var context;
if (typeof createContext === 'function') {
    context = createContext({
        t: function (k) { return (Array.isArray(k) ? k[0] : k); },
        lang: '',
    });
}
export default context;
